import { render, staticRenderFns } from "./SoldItemsPerSupplier.vue?vue&type=template&id=06c92b12&scoped=true&"
import script from "./SoldItemsPerSupplier.vue?vue&type=script&lang=js&"
export * from "./SoldItemsPerSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c92b12",
  null
  
)

export default component.exports